// extracted by mini-css-extract-plugin
module.exports = {"removeSpacing":"styles_removeSpacing__CJvSm","relative":"styles_relative__0nU6N","transition":"styles_transition__pzwnJ","pageTitle":"styles_pageTitle__jgG9c"};